import { Theme, Components } from '@mui/material/styles';

export const MenuOverrides: Components<Theme> = {
  MuiMenu: {
    defaultProps: {},
    styleOverrides: {
      root: () => ({}),
    },
  },
  MuiMenuList: {
    defaultProps: {},
    styleOverrides: {
      padding: 0,
    },
  },
  MuiMenuItem: {
    defaultProps: {},
    styleOverrides: {
      root: () => ({
        fontSize: 16,
        textTransform: 'uppercase',
        textAlign: 'center',
      }),
    },
  },
};
